import classNames from 'classnames';
import React from 'react';
import bn from 'utils/bemnames';
const bem = bn.create('page');

const Page = ({ className, children, fluid = true, styles, ...restProps }) => {
  return (
    <div
      className={classNames(bem.b('px-md-3 mt-3'), className, {
        'container-fluid': fluid,
        container: !fluid,
      })}
      style={{ minHeight: 'calc(100vh - 70px)', marginBottom: '7rem', ...styles }}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default Page;
